import { Button, Card, Col, Description, DescriptionItem, Divider, Notification, Row, Spacer } from '@app/components'
import { InfoCircleOutlined } from '@app/components/icons'
import { toCurrency } from '@app/utils'
import useApprove from 'libs/services/hooks/useApprove'
import useLock from 'libs/services/hooks/useLock'
import React, { useState } from 'react'

export const Summary: React.FC<{
  wallet: string
  lockingTokens: number
  setLockingTokens: (value: number) => void
  approvingTokens: number
  setApprovingTokens: (value: number) => void
  lockedToken: number
  approvedToken: number
  currentDiscount: number
  newDiscount: number
  asset: any
  balance: number
  chain: number
  title: string
}> = ({
  wallet,
  lockingTokens,
  setLockingTokens,
  approvingTokens,
  setApprovingTokens,
  lockedToken,
  approvedToken,
  currentDiscount,
  newDiscount,
  balance,
  chain,
  title,
}) => {
  const [videoOpen, setVideoOpen] = useState(false)

  const descriptionItemStyle: React.CSSProperties = {
    justifyContent: 'end',
  }
  const lockTokens = () => {
    lock.write()
  }
  const after = (func) => {
    if (func == 'Lock') setLockingTokens(0)
    if (func == 'Approve') setLockingTokens(approvingTokens)
    setApprovingTokens(0)
    Notification({ message: `${func} Successful!`, type: 'success' })
  }

  const approveTokens = () => {
    approve.write()
  }

  const lock = useLock(lockingTokens * 10 ** 8, () => after('Lock'))
  const approve = useApprove(approvingTokens * 10 ** 8, () => after('Approve'))

  return (
    <>
      <Card>
        <Description
          title={
            <Row align="middle" gutter={0}>
              <span>Fee Summary</span>
              <Button type="text" size="small" onClick={() => setVideoOpen(true)}>
                <InfoCircleOutlined size={20} />
              </Button>
            </Row>
          }
          column={1}
        >
          <DescriptionItem label={'Wallet'} contentStyle={descriptionItemStyle}>
            {wallet}
          </DescriptionItem>
          <DescriptionItem label={'Locked tokens'} contentStyle={descriptionItemStyle}>
            {toCurrency(lockedToken, false)}
          </DescriptionItem>
          <DescriptionItem label={'Locking tokens'} contentStyle={descriptionItemStyle}>
            {toCurrency(lockingTokens, false)}
          </DescriptionItem>
        </Description>

        <Divider />

        <Description column={1}>
          <DescriptionItem label="New Locked" contentStyle={descriptionItemStyle}>
            {toCurrency(lockedToken + lockingTokens, false)}
          </DescriptionItem>
          <DescriptionItem label={chain == 1 ? 'Current Tier' : 'Current Tier'} contentStyle={descriptionItemStyle}>
            {currentDiscount}
          </DescriptionItem>
          <DescriptionItem label={chain == 1 ? 'New Tier' : 'New Tier'} contentStyle={descriptionItemStyle}>
            {newDiscount}
          </DescriptionItem>
        </Description>
        <Spacer />
        <Row>
          <Col span={12}>
            <Button
              block
              onClick={() => approveTokens()}
              loading={approve.state == 'loading'}
              disabled={approvedToken >= lockingTokens || lockingTokens > balance || approvingTokens == 0}
            >
              Approve {toCurrency(lockingTokens >= 0 ? lockingTokens : 0, false)} {title}
            </Button>
          </Col>
          <Col span={12}>
            <Button
              block
              onClick={() => lockTokens()}
              loading={lock.state == 'loading'}
              disabled={
                approvedToken < lockingTokens ||
                lockingTokens == 0 ||
                lockingTokens > balance ||
                lock.state != 'enabled'
              }
            >
              Lock {toCurrency(lockingTokens, false)} {title}
            </Button>
          </Col>
        </Row>
      </Card>
      {videoOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
          onClick={() => setVideoOpen(false)}
        >
          <div
            style={{
              position: 'relative',
              width: '80%',
              maxWidth: '800px',
              background: '#fff',
              borderRadius: 8,
              overflow: 'hidden',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setVideoOpen(false)}
              style={{
                position: 'absolute',
                top: 8,
                right: 8,
                background: 'transparent',
                border: 'none',
                fontSize: 24,
                cursor: 'pointer',
              }}
            >
              ×
            </button>
            <iframe
              width="100%"
              height="450"
              src={'https://www.youtube.com/embed/yA39wXcisIk?si=4XMK-9Me0lKjQv20'}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </>
  )
}
